import { script } from 'playcanvas';

 
export const ASSET_PREFIX = "";
export const SCRIPT_PREFIX = "";
export const SCENE_PATH = "2550881.json";

export const CONTEXT_OPTIONS = {
    'antialias': true,
    'alpha': false,
    'preserveDrawingBuffer': false,
    'deviceTypes': [`webgl2`, `webgl1`],
    'powerPreference': "low-power"
};

export const SCRIPTS = [ 298913863, 298913847, 298913816, 298913848, 298913693, 298913849, 298913896, 298913777, 298913928, 298913834, 298913912, 298913913, 298913822, 298913919, 298913917, 298913927, 298913854, 298913926, 298913918, 298913808, 298913825, 298913952, 298913929, 298913710, 298913831, 298913986, 298913960, 298913951, 298913668, 298913728, 298913820, 298913944, 298913938, 298913940, 298913937, 298913931, 298913942, 298913947, 298913699, 298913961, 298913826, 298913993, 298913658, 298913821, 298913983, 298913716, 298913852, 298913853, 298913989, 298913692, 298913823, 298913925, 298913812, 298913990, 298913998, 299171838, 299172870, 299233789, 299248732, 299249720, 299420489, 299420793, 299423172, 299423173, 299423174, 299433293, 299588145, 299589102, 299892910, 299896289, 299896610, 299897203, 301563660, 301805819, 301806671, 301823890, 301823891, 301930140, 302282308 ];
export const CONFIG_FILENAME = "config.json";
export const INPUT_SETTINGS = {
    useKeyboard: true,
    useMouse: true,
    useGamepads: false,
    useTouch: true
};
export const PRELOAD_MODULES = [
    {'moduleName' : 'Ammo', 'glueUrl' : 'files/assets/298913893/1/ammo.wasm.js', 'wasmUrl' : 'files/assets/298913895/1/ammo.wasm.wasm', 'fallbackUrl' : '', 'preload' : true},
    {'moduleName' : 'BASIS', 'glueUrl' : 'files/assets/298913756/1/basis.wasm.js', 'wasmUrl' : 'files/assets/298913839/1/basis.wasm.wasm', 'fallbackUrl' : 'files/assets/298913838/1/basis.js', 'preload' : false},
    {'moduleName' : 'DracoDecoderModule', 'glueUrl' : 'files/assets/298913903/1/draco.wasm.js', 'wasmUrl' : 'files/assets/298913904/1/draco.wasm.wasm', 'fallbackUrl' : 'files/assets/298913905/1/draco.js', 'preload' : true},
];
    
script.legacy = false;
